document.addEventListener("DOMContentLoaded", (event) => {

    const MyfPopin = document.getElementsByClassName('__MyfPopin');
    const MyfPopinOpen = document.getElementsByClassName('__MyfPopin-open');
  
    Array.prototype.forEach.call(MyfPopinOpen,
      function(CurrentPopin) {
        let MyfPopinBtnOpen = CurrentPopin.getAttribute('data-popinid');
        let MyfPopinContent = document.getElementById(MyfPopinBtnOpen);
        let MyfPopinBtnClose = MyfPopinContent.querySelector('.__MyfPopin-close');
  
        if (CurrentPopin.getAttribute('data-popinid') !== 'site-footer__newsletter__form') {
          CurrentPopin.addEventListener('click', (event) => {
            event.stopPropagation();
            MyfPopinContent.classList.add("MyfPopin--active");
          });
        }
        if(MyfPopinBtnClose) MyfPopinBtnClose.addEventListener('click', () => {
          MyfPopinContent.classList.remove("MyfPopin--active");
        });
      });

      document.addEventListener('click', function(event) {
        // Sélectionne la classe que tu veux exclure des clics
        const classToExclude = 'MyfPopin--active';
    
        // Vérifie si l'élément cliqué ou l'un de ses parents contient la classe à exclure
        if (event.target.closest(`.${classToExclude}`) ) {
            // Si c'est le cas, ne fais rien et quitte la fonction
            return;
        } else {        
          document.querySelectorAll('.__MyfPopin').forEach(function(div) {
            if (div.id !== 'site-footer__newsletter__form') {
              // console.log('close popin');
              div.classList.remove("MyfPopin--active");
            }
          });
        }
    });
  
  });
  